import React from 'react';
import { Badge } from 'react-bootstrap';

export function PaymentStatusBadge({ state }) {
  switch (state) {
    case 'paid':
      return <Badge bg="success">Paid</Badge>;
    case 'not_paid':
      return <Badge bg="danger">Not Paid</Badge>;
    case 'partial':
      return <Badge bg="warning" text="dark">Partial</Badge>;
    case 'reversed':
      return <Badge bg="info">Reversed</Badge>;
    case 'in_payment':
      return <Badge bg="info">In Payment</Badge>;
    default:
      return <Badge bg="secondary">{state}</Badge>;
  }
}
